import * as types from 'modulesV2/constants/ui';

export function setScreenSize(innerWidth) {
  return {type: types.SCREEN_RESIZED, innerWidth};
}
